import { useQuery } from "@tanstack/react-query";
import { GQLPosts, GQLUrls } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import {
    ICategoryArticlesPageProps,
    TranslationsObject,
} from "@genericTypes/sharedTypes";
import BlogPosts from "@components/shared/blogPosts";
import NotFoundImg from "./notFoundImg";
import LinkButton from "@components/shared/form/linkButton";
import { resolveURL } from "@lib/sharedUtils";

export default function Blogs() {
    const { data: props } = useQuery<ICategoryArticlesPageProps, Error>([
        "articlesPageProps",
    ]);
    const { category, currentPage, total, articles, isNews } = props ?? {};
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <>
            {articles?.map((i) => i.category?.posts).flat().length === 0 ? (
                <div className=" w-fit flex flex-col   items-center  mx-auto text-center">
                    <h1 className="capitalize lg:text-4xl text-xl lg:leading-[63px] leading-9 text-center font-bold">
                        {` ${translate(
                            translations,
                            isNews
                                ? "several_general_discoverTopNews"
                                : "several_general_discoverTopBlogs",
                        )} ${
                            (category?.label as string) ??
                            (category?.name as string)
                        }`}
                    </h1>
                    <div className=" w-[250px] lg:w-auto">
                        <NotFoundImg />
                    </div>
                    <p className="mt-10 lg:text-xl text-base  leading-5 font-medium ">
                        {translate(
                            translations,
                            "several_articlesPage_noArticlesMessage",
                        )}
                    </p>
                    <LinkButton
                        className="max-w-[245px] mt-5 lg:text-lg text-base font-bold hover:no-underline"
                        href="/blog"
                    >
                        {translate(translations, "several_general_seeOurBlogs")}
                    </LinkButton>
                </div>
            ) : (
                <section className="">
                    <h1 className=" lg:text-4xl text-xl lg:leading-[63px] leading-9 text-center font-bold">
                        {` ${translate(
                            translations,
                            isNews
                                ? "several_general_discoverTopNews"
                                : "several_general_discoverTopBlogs",
                        )} ${
                            !isNews
                                ? (category?.label as string) ??
                                  (category?.name as string)
                                : ""
                        }`}
                    </h1>
                    <h3
                        className={`  lg:text-xl text-sm  lg:leading-9 leading-6 text-center px-5`}
                    >
                        {translate(
                            translations,
                            isNews
                                ? "several_newsPage_mainDescription"
                                : "several_articlesPage_mainDescription",
                        )}
                    </h3>
                    <BlogPosts
                        posts={articles as GQLPosts[]}
                        title=""
                        type="pagination"
                        currentPage={currentPage as number}
                        url={`${resolveURL(category?.url as GQLUrls)}/${
                            isNews ? "news-articles" : "articles"
                        }`}
                        total={total}
                    />
                </section>
            )}
        </>
    );
}
